import {createFileRoute} from '@tanstack/react-router';

import {userKeys} from '@/features/User/api/queryKeys';
import {getUser} from '@/features/User/api/readUser';
import {UserForm} from '@/features/User/components/UserForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_company/users_/update/$userId')({
  component: UserForm,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(`Edit ${params.userId}`);

    return {
      ...context,
      readUserQuery: {
        queryKey: userKeys.detail(params.userId),
        queryFn: () => getUser(params.userId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readUserQuery);
  },
});
